import { graphql } from "@/lib/gql/__generated__";

export const CampaignList_Top_Query = graphql(`
	query VoucherForCampaignListByHotelID($hotelID: ID!) {
		voucherForCampaignListByHotelID(hotelID: $hotelID) {
			id
			voucherForCampaignList {
				hotelID
				voucherID
				inSale
				name
				description
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				voucherPrice {
					currencyType
					amount
				}
				resourceAvailablePrice {
					currencyType
					amount
				}
				voucherGiftList {
					guestName
					guestTel
					guestEmail
				}
				voucherExplanationForHost
				mailTemplate
				cinStart
				cinEnd
				createdAt
				deletedAt
			}
		}
	}
`);
